import * as React from 'react';

import {RetriggerPopupConfigurationContext, frameworkRetriggerPopup} from './retriggerPopupconfiguration';

const withRetriggerPopuConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <RetriggerPopupConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkRetriggerPopup}/>
                );
            }}
        </RetriggerPopupConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withRetriggerPopuConfiguration;